import React, { Component } from 'react';
import { object } from 'prop-types';
import axios from 'axios';
import { metric, logger } from '@fiverr-private/perseus';
import SafePureComponent from '../shared/SafePureComponent';
import GigGallery from './GigGallery';

import './style.scss';

export const WAVEFORM_BATCH_SIZE = 5;

const formatSlides = (gallery) => {
    if (!gallery || !gallery.slides){
        return [];
    }

    return gallery.slides
        .filter((slideObj) => slideObj && !!slideObj.slide)
        .map((slideObj) => slideObj.slide);
};

class Gallery extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slides: formatSlides(props.gallery)
        };
    }

    async componentDidMount() {
        const { slides } = this.state;
        const { general, pathfinderWrapper } = this.context;

        const waveformIds = slides.reduce((acc, slide) => {
            if (slide.itemScopeType === 'AudioSlide') {
                acc.push(slide.waveformId);
            }

            return acc;
        }, []);

        while (waveformIds.length) {
            const waveformIdsBatch = waveformIds.splice(0, WAVEFORM_BATCH_SIZE);
            const url = pathfinderWrapper.pathfinder('gig_page_fetch_waveforms', { gig_id: general.gigId, waveform_ids: waveformIdsBatch });

            try {
                const { data } = await axios.get(url);
                const { waveforms } = data;

                if (!Array.isArray(waveforms) || !waveforms.length) {
                    return;
                }

                const newSlides = this.state.slides.map((slide) => {
                    const waveform = waveforms.find((waveform) => waveform.id === slide.waveformId);
                    if (waveform) {
                        return { ...slide, waveform: waveform.waveformData };
                    } else {
                        return slide;
                    }
                });

                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    slides: newSlides
                });
            } catch (error) {
                const status = error.response && error.response.status || 'unknown';
                metric.count(`bad_response.waveform.${status}`);
                logger.warn(error, { message: 'Failed to fetch waveforms' });
            }
        }
    }

    render() {
        const { slides } = this.state;

        return (
            <GigGallery slides={slides}/>
        );

    }
}

Gallery.propTypes = {
    gallery: object.isRequired
};

Gallery.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { Gallery };
export default SafePureComponent(Gallery);
